import { render, staticRenderFns } from "./PageSteps.vue?vue&type=template&id=0e97e6a7"
import script from "./PageSteps.vue?vue&type=script&lang=js"
export * from "./PageSteps.vue?vue&type=script&lang=js"
import style0 from "./PageSteps.vue?vue&type=style&index=0&id=0e97e6a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports